module.exports = __webpack_public_path__ + "img/logo.87586533.svg";